import React from "react";
import { compose, withHandlers } from "recompose";
import { LocalForm, actions } from "react-redux-form";
import {
  Page,
  onMount,
  FormGroup,
  DatePicker,
  SubmitButton,
} from "components/common";
import { getMonthEnd } from "./util";
import { ReportContainer } from "./components";

export const AgedPayablesByContact = ({
  data,
  item,
  handleSubmit,
  setState,
}) => (
  <Page title={data.ReportTitles[0]} translate={false}>
    <LocalForm
      className="d-print-none"
      getDispatch={(dispatch) => setState({ dispatch })}
      onSubmit={handleSubmit}
      initialState={item}
    >
      <div className="d-flex align-items-center">
        <FormGroup label="Show Payments To" className="mr-3">
          <DatePicker model=".date" className="form-control" />
        </FormGroup>
        <FormGroup label="From Date" className="mr-3">
          <DatePicker model=".fromDate" className="form-control" />
        </FormGroup>
        <FormGroup label="To Date" className="mr-3">
          <DatePicker model=".toDate" className="form-control" />
        </FormGroup>
        <FormGroup label="&nbsp;">
          <SubmitButton size="sm" className="d-block">
            Update
          </SubmitButton>
        </FormGroup>
      </div>
    </LocalForm>
    <ReportContainer report={data} />
  </Page>
);

const loadReport = (item, xero) =>
  xero
    .get("reports/AgedPayablesByContact", {
      params: {
        extra_params: item,
      },
    })
    .get("data");

export const enhance = compose(
  onMount(({ xero, match }) => () => {
    const item = {
      contactID: match.params.id,
      date: getMonthEnd(),
      fromDate: null,
      toDate: getMonthEnd(),
    };

    return Promise.props({
      data: loadReport(item, xero),
      item,
    });
  }),
  withHandlers({
    handleSubmit:
      ({ setState, xero, dispatch }) =>
      (item) => {
        return loadReport(item, xero)
          .then((data) => setState({ data }))
          .finally(() => dispatch(actions.setSubmitted("local", true)));
      },
  })
);

export default enhance(AgedPayablesByContact);
